import React from 'react';

interface Props {
  children?: any;
  mb?: number;
  classes: any;
}

// Style
import injectSheet from 'react-jss';
const styles = theme => {
  return {
    root: {
      marginBottom: theme.spacing.unit * 4,
      padding: 0,
    },
  };
};

function InputRow({ children, classes, mb }: Props) {
  return (
    <div className={classes.root} style={{ marginBottom: mb }}>
      {children}
    </div>
  );
}

export default injectSheet(styles)(InputRow);
